import React, { memo } from 'react';
import { Plus, MessageSquare, X } from 'lucide-react';
import { cn } from '../../utils';
import './ChatHistorySidebar.css';

export interface ChatHistoryItem {
  id: string;
  title: string;
  date: string;
}

interface ChatHistorySidebarProps {
  isOpen: boolean;
  onClose: () => void;
  items: ChatHistoryItem[];
  selectedId: string | null;
  onSelectChat: (id: string) => void;
  onNewChat: () => void;
  isLoading?: boolean;
  error?: string | null;
  className?: string;
}

const ChatHistorySidebarComponent: React.FC<ChatHistorySidebarProps> = ({
  isOpen,
  onClose,
  items,
  selectedId,
  onSelectChat,
  onNewChat,
  isLoading = false,
  error = null,
  className,
}) => {
  return (
    <>
      <div
        className={cn('sidebar-overlay', isOpen && 'sidebar-overlay--visible')}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className={cn(
          'sidebar',
          isOpen && 'sidebar--open',
          className
        )}
        aria-label="История чатов"
      >
        <div className="sidebar__header">
          <h2 className="sidebar__title">История</h2>
          <button
            type="button"
            className="sidebar__close"
            onClick={onClose}
            aria-label="Закрыть меню"
          >
            <X size={20} />
          </button>
        </div>

        <button
          type="button"
          className="sidebar__new-chat"
          onClick={() => {
            onNewChat();
            onClose();
          }}
        >
          <Plus size={18} />
          <span>Новый чат</span>
        </button>

        <nav className="sidebar__nav">
          {isLoading && (
            <p className="sidebar__empty">Загрузка...</p>
          )}
          {error && !isLoading && (
            <p className="sidebar__error">{error}</p>
          )}
          {!isLoading && !error && (
            <ul className="sidebar__list">
              {items.map((item) => (
                <li key={item.id} className="sidebar__item">
                  <button
                    type="button"
                    className={cn(
                      'sidebar__link',
                      selectedId === item.id && 'sidebar__link--active'
                    )}
                    onClick={() => {
                      onSelectChat(item.id);
                      onClose();
                    }}
                  >
                    <MessageSquare size={16} className="sidebar__link-icon" />
                    <span className="sidebar__link-title">{item.title}</span>
                    <span className="sidebar__link-date">{item.date}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </nav>

        {!isLoading && !error && items.length === 0 && (
          <p className="sidebar__empty">Пока нет диалогов</p>
        )}
      </aside>
    </>
  );
};

export const ChatHistorySidebar = memo(ChatHistorySidebarComponent);
